<aside class="bestellassistent">
    <button type="button" class="assistant-close-button" (click)="close()">

        <mat-icon fontSet="material-icons-outlined">
            close
        </mat-icon>

    </button>

    <h2>
        <mat-icon fontSet="material-icons-outlined">
            monitoring
        </mat-icon>

        Bestellassistent
    </h2>

    @if (selectedArtikel(); as item) {

    <section class="selected-card">
        <div class="article-number">
            {{ item.nummer }}
        </div>

        <div>
            <strong>
                {{ item.name }}
            </strong>

            <span>
                {{ item.beschreibung }}
            </span>

            <small>
                Vorbestellt:
                <b>
                    {{ vorbestelltValue() }}
                    {{ quantityUnit() }}
                </b>
            </small>

            @if (vorbestelltCalculationLabel(); as calculationLabel) {
            <small class="quantity-calculation">
                {{ calculationLabel }}
            </small>
            }
        </div>
    </section>

    @if (isLoading()) {

    <section class="assistant-empty">
        <mat-icon fontSet="material-icons-outlined">
            hourglass_empty
        </mat-icon>

        <span>
            Bestellassistent-Daten werden geladen...
        </span>
    </section>

    } @else if (loadError()) {

    <section class="assistant-empty">
        <mat-icon fontSet="material-icons-outlined">
            error_outline
        </mat-icon>

        <span>
            {{ loadError() }}
        </span>
    </section>

    } @else {

    <section class="assistant-card recommendation-card">
        <header>
            <mat-icon fontSet="material-icons-outlined">
                auto_awesome
            </mat-icon>

            <strong>
                Empfohlene Menge
            </strong>
        </header>

        <div class="recommendation-value">
            <strong>
                {{ recommendationValue() }}
            </strong>

            <span>
                {{ quantityUnit() }}
            </span>
        </div>

        @if (recommendationCalculationLabel(); as calculationLabel) {
        <small class="quantity-calculation recommendation-calculation">
            {{ calculationLabel }}
        </small>
        }

        <p>
            Ø Verkauf: {{ averageSales() }} Stk/Woche ·
            Ø Retoure: {{ averageRetoure() }} ·
            <span class="trend-label">
                {{ trendLabel() }}
            </span>
        </p>
    </section>

    <section class="assistant-card">
        <header>
            <mat-icon fontSet="material-icons-outlined">
                calendar_month
            </mat-icon>

            <strong>
                Verlauf der letzten Wochen
            </strong>
        </header>

        @if (weeklyData().length === 0) {

        <section class="assistant-empty">
            <mat-icon fontSet="material-icons-outlined">
                bar_chart_off
            </mat-icon>

            <span>
                Keine Verlaufsdaten vorhanden.
            </span>
        </section>

        } @else {

        <div class="chart-area">

            <div class="y-axis">
                @for (value of yAxisValues(); track value) {
                <span>
                    {{ value }}
                </span>
                }
            </div>

            <div class="chart">

                <span class="average-line" [style.bottom.%]="averageSoldLinePosition()">
                </span>

                @for (week of weeklyData(); track week.kw; let i = $index) {

                <div class="chart-group">

                    <div class="bar-hover-area">

                        <div class="bar-wrapper">

                            <span class="bar ordered" [style.height.%]="getBarHeight(week, 'bestellt')">
                            </span>

                            <span class="bar sold" [class.sold-positive]="getSoldBarClass(i) === 'sold-positive'"
                                [class.sold-negative]="getSoldBarClass(i) === 'sold-negative'"
                                [class.sold-neutral]="getSoldBarClass(i) === 'sold-neutral'"
                                [style.height.%]="getBarHeight(week, 'verkauft')">
                            </span>

                        </div>

                        <div class="chart-tooltip">
                            <strong>
                                KW {{ week.kw }}
                            </strong>

                            <span>
                                Bestellt: {{ week.bestellt }}
                            </span>

                            <span>
                                Verkauft: {{ week.verkauft }}
                            </span>
                        </div>

                    </div>

                    <small>
                        {{ week.kw }}
                    </small>

                </div>

                }

            </div>

        </div>

        <div class="chart-legend">
            <span>
                <i class="ordered-dot"></i>
                Bestellt
            </span>

            <span>
                <i class="sold-dot"></i>
                Verkauft
            </span>
        </div>

        }

    </section>

    <div class="metric-grid">

        <section class="metric-card">
            <span>
                Ø Verkauf / Woche
            </span>

            <strong>
                {{ averageSales() }}
            </strong>
        </section>

        <section class="metric-card">
            <span>
                Verkaufsquote
            </span>

            <strong class="success-value">
                {{ salesRate() }}%
            </strong>

            <div class="progress">
                <span [style.width.%]="salesRate()"></span>
            </div>
        </section>

        <section class="metric-card">
            <span>
                Retouren (gesamt)
            </span>

            <strong>
                {{ totalRetouren() }}
            </strong>
        </section>

        <section class="metric-card">
            <span>
                Entlastet (gesamt)
            </span>

            <strong>
                {{ totalEntlastet() }}
            </strong>
        </section>

    </div>

    <section class="assistant-card weekly-details-card">
        <header>
            <strong>
                Wochendetails
            </strong>
        </header>

        <div class="weekly-details-list">

            @if (weeklyDetails().length === 0) {

            <div class="weekly-detail-row">
                <strong>
                    Keine Daten
                </strong>
            </div>

            } @else {

            @for (week of weeklyDetails(); track week.kw) {

            <div class="weekly-detail-row">

                <strong>
                    KW {{ week.kw }}
                </strong>

                <div>
                    <span>
                        Best.
                        <b>{{ week.bestellt }}</b>
                    </span>

                    <span>
                        Verk.
                        <b class="success-value">
                            {{ week.verkauft }}
                        </b>
                    </span>

                    <span>
                        Δ
                        <b>{{ week.differenz }}</b>
                    </span>
                </div>

            </div>

            }

            }

        </div>
    </section>

    }

    } @else {

    <section class="assistant-empty">
        <mat-icon fontSet="material-icons-outlined">
            touch_app
        </mat-icon>

        <span>
            Bitte einen Artikel auswählen.
        </span>
    </section>

    }

</aside>